import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { SnButtonModule } from '@lib/ui/button';
import { TranslationModule } from '@lib/translation/translation.module';

import { SnWeeklySchedulerComponent } from './components/weekly-scheduler';

@NgModule({
  imports: [CommonModule, SnButtonModule, MatButtonModule, TranslationModule],
  exports: [SnWeeklySchedulerComponent],
  declarations: [SnWeeklySchedulerComponent],
})
export class SnSchedulerModule {}
